// extracted by mini-css-extract-plugin
export default {"sentry":"oyh74gQU","title":"zzh5tZwz","subtitle":"fYB1zYZQ","link":"EtoOsg7B","btn":"NKnzi6is"};